import { invariant } from '@seen/core/invariant'

const PRINT_DELAY_MS = 250

export function printHtmlDocument(html: string, target?: Window | null): void {
  if (target && !target.closed) {
    writeAndPrint(target, html)
    return
  }

  const iframe = document.createElement('iframe')
  iframe.title = 'Print CCDA'
  iframe.setAttribute('aria-hidden', 'true')
  iframe.style.position = 'fixed'
  iframe.style.right = '0'
  iframe.style.bottom = '0'
  iframe.style.width = '8.5in'
  iframe.style.height = '11in'
  iframe.style.opacity = '0'
  iframe.style.border = '0'
  iframe.style.pointerEvents = 'none'
  document.body.appendChild(iframe)

  const iframeWindow = iframe.contentWindow
  invariant(iframeWindow, 'Print frame is not available')
  iframeWindow.addEventListener('afterprint', () => iframe.remove(), {
    once: true,
  })
  writeAndPrint(iframeWindow, html)
}

export function openCcdaPrintWindow(): Window | null {
  const printWindow = window.open('about:blank', 'ccda-print')
  if (!printWindow) {
    return null
  }
  writeAndPrint(
    printWindow,
    '<!doctype html><html><head><title>Preparing PDF…</title></head><body><p>Preparing PDF…</p></body></html>',
    false
  )
  return printWindow
}

function writeAndPrint(target: Window, html: string, shouldPrint = true): void {
  target.document.open()
  target.document.write(html)
  target.document.close()
  if (!shouldPrint) {
    return
  }
  window.setTimeout(() => {
    if (target.closed) {
      return
    }
    target.focus()
    target.print()
  }, PRINT_DELAY_MS)
}
